import { gql } from '@apollo/client';

export const fetchLinkedEntitlementsForChangeSubcsription = gql`
  fragment PromotionsQuery on Promotion {
    id
    promotionCode
    title
    type
    benefits {
      benefitType
      duration
      subBenefitType
      iterations
      value
      scale
      type
      customisable {
        value {
          type
          lowerBound
          upperBound
        }
        iterations {
          type
          lowerBound
          upperBound
        }
        duration
      }
    }
    promotionInstanceId
    promotionWindow {
      endTime
      startTime
    }
    status
    cycleInterval
    pricingType
    eligibilityRules {
      products
      cycleInterval
      pricingType
      partnerType
      partnerTier
      saleTransitionType
      currency
    }
    cycleIntervalWithEligibleConditions
    applicationReason {
      id
      readableName
      customisable {
        id {
          type
          anyOf {
            readableName
            id
          }
        }
      }
    }
    isPromotionCustomisable
  }

  query fetchLinkedEntitlementsForChangeSubcsription(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $skipUpgradeTrialField: Boolean!
  ) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        productId
        activeUsers
        entitlementNumber
        endTimestamp
        productName
        billingCycle
        billingFrequency
        latestPeriodEndDate
        offeringId
        subscriptionId
        billingStatus
        isApp
        transactionAccountId
        billingGroupId
        edition
        isSandbox
        parentSen
        logoId
        userTier
        unitCount
        promotions {
          ...PromotionsQuery
        }
        scheduledChanges {
          promotions {
            ...PromotionsQuery
          }
        }
        offering {
          id
          name
          productKey
          level
          type
          pricingType
          status
        }
        pricingPlan {
          type
          billingFrequency
          id
          currency
          pricingPlanType
          status
          description
          chargeElement
          chargeType
          tiers {
            unitAmount
            flatAmount
            floor
            ceiling
          }
        }
        subscriptionTimestamps {
          firstStartTimestamp
          lastEndTimestamp
          firstTrialStartTimestamp
          lastTrialEndTimestamp
        }
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
        upgradeTrial @skip(if: $skipUpgradeTrialField) {
          pricingPlan {
            type
            billingFrequency
            id
            currency
            pricingPlanType
            status
            description
            chargeElement
            chargeType
            tiers {
              unitAmount
              flatAmount
              floor
              ceiling
            }
          }
          startTimestamp
          endTimestamp
        }
      }
    }
  }
`;
